export default __webpack_public_path__ + "static/media/Dogtown_avatar.040eda49.png";